module.exports = __webpack_public_path__ + "img/video.9db98837.png";